import { render, staticRenderFns } from "./NetworkCalculationDetails.vue?vue&type=template&id=24091d7a"
import script from "./NetworkCalculationDetails.vue?vue&type=script&lang=js"
export * from "./NetworkCalculationDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports